export default {
  API_URL: 'https://ashtead-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://ashteadsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
